import React from 'react';
import { connect } from 'react-redux';
import { resourceApi } from '../utils/fetchUtil';
import Paper from 'material-ui/Paper';
import Header from '../Components/Header/HeaderSmall';
import RaisedButton from 'material-ui/RaisedButton';
import TabStrip  from '../Components/TabStrip';
import ContactCareGuidePhone from 'material-ui/svg-icons/communication/phone';
import {fireInAppBrowserPlugin} from '../actions/environmentActions'

class Teledoc extends React.Component {

    constructor(props) {
        super(props);
        this.state = {  
            template:null
        };
    }

    componentDidMount() {
        this.loadContent();
    }

    loadContent() {
    
        var self = this;

        this.setState({isFetching: true});

        let config = {
            method: 'get',
            url: `member/teledoc`
        };

        resourceApi(config) 
        .then(function (response) {
            self.setState({ template: response.data, isFetching: false }); 
        })
        .catch(function (error) {
            console.log(error);
        });
    }

    action = () => {
        var self = this;

        this.setState({isFetching: true});

        let config = {
            method: 'get',
            url: `member/teledoc/contact`
        };

        resourceApi(config) 
        .then(function (response) {
            self.setState({ result: response.data, isFetching: false }); 
        })
        .catch(function (error) {
            console.log(error);
        });
    }

    fire(){   
        let config = {
            method: 'get',
            url: `log/teledoc/`
        };

        resourceApi(config);  
    }
    
    getContent = () => {
        return {__html: this.state.template.Content};
    }
    
    render() {
        
        return (
            
            <div>
                {this.state.template && (
                <div>
                        <Header title={this.state.template.Header}  />
                        <div className="container trueno" style={{marginTop: 20, textAlign: 'center'}}>
                            <Paper>
                                <div className="container truenoLight" >
                                    <h4>{this.state.template.Title}</h4>
                                    <img src={this.state.template.Url} style={{width:320}} />
                                    {!this.state.fetching && (
                                        <div>
                                            <div dangerouslySetInnerHTML={this.getContent(this.state.template.Content)} />
                                            <br />
                                            <br />
                                            {this.state.template.PhoneNumber && (
                                                <div>
                                                    <a style={{ textDecoration:"none"}} onClick={() =>{this.fire(); fireInAppBrowserPlugin("tel:" + this.state.template.PhoneNumber)}} >
                                                        <RaisedButton icon={<ContactCareGuidePhone />}  primary={true} label={this.state.template.Button}  />
                                                    </a>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                    <br />
                                    <br />
                                </div>
                            </Paper>
                        </div>
                    </div>
                )}
                <br />
                <br />
                <br />
                <br />
                <br />
                <TabStrip activeTab={29} />
            </div>
        );
  }
};

//export default MyBenefits;

const mapDispatchToProps = (dispatch) => {
  return {
   
  }
}

const mapStateToProps = (state) => ({
    member: state.thisApp.auth.member
})


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Teledoc)



// WEBPACK FOOTER //
// ./src/Pages/Teledoc.js